<template>
    <FormSection title="DME Needed" :full-height="false" :application-id="referral.application">
        <template v-slot:content>
            <section class="row g-0 p-4 pb-0">
                <div class="col-12 py-2">
                    <div class="d-flex align-items-center justify-content-center">
                        <div class="form-group pe-4 col-5">
                            <label for="equipment-name"> Equipment Name </label>
                            <TypeaheadInput
                                placeholder="Start Typing"
                                :getData="getDmesList"
                                v-on:valueChanged="changeDmeId"
                                :value="dmeId"
                            />
                        </div>
                        <div class="form-group col-7 mt-4">
                            <button class="btn btn-md btn-primary px-3" @click="addDme()">Add DME</button>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group col-12">
                        <table class="table table-responsive-md border border-gray">
                            <thead>
                                <tr class="bg-table-header">
                                    <th>Equipment Name</th>
                                    <th>Provider Name</th>
                                    <th>Model Number</th>
                                    <th>Serial Number</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody v-if="isLoading || isError || !hasData">
                                <!-- LOADING -->
                                <template v-if="isLoading">
                                    <tr v-for="i of loadingCount" :key="i" class="table-loading">
                                        <td v-for="i of columns" :key="i">
                                            <span class="shimmer-loading"></span>
                                        </td>
                                    </tr>
                                </template>
                                <!-- EMPTY -->
                                <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                                    <td :colspan="columns">
                                        <h3>No DMEs Found.</h3>
                                    </td>
                                </tr>
                                <!-- ERROR -->
                                <tr class="table-error" v-if="!isLoading && isError">
                                    <td :colspan="columns">
                                        <ErrorMessageHandler title="Contact list" :try-again="getDme" />
                                    </td>
                                </tr>
                            </tbody>
                            <template v-else>
                                <tbody v-for="dme of dmes" :key="dme.id">
                                    <EditDmeNeededRow
                                        :columns="columns"
                                        :dme="dme"
                                        :refresh-list="getDme"
                                        :patient-id="patientId"
                                        :referral="referral"
                                    />
                                </tbody>
                            </template>
                        </table>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group col-12 ps-3">
                        <label for="non-standard-items"> Non Standard Items</label>
                        <CommentInput
                            input-name="referral-comments"
                            :result="referral.otherDME"
                            :class-list="commentInputClass"
                            :max-length="250"
                            :show-template-typeahead="showTemplate"
                            v-on:resultUpdatedAppended="resultUpdatedAppended"
                            v-on:resultUpdated="resultUpdated"
                        >
                        </CommentInput>
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./EditDmeNeeded.ts"></script>
